import { WhatsApp } from '@mui/icons-material'
import { Button } from '@mui/material'
import { FunctionComponent, useState } from 'react'

import { useWaapi } from '../hooks/useWaapi.ts'
import { nombreArchivoWaapi, waapiDocumento } from '../services/waapiMensaje.ts'
import WaapiEnviarDialog from './WaapiEnviarDialog'

/**
 * Datos que entrega el diálogo de impresión a sus acciones extra. Se declara aquí con la misma forma
 * que `ImpresionAccionExtraContext` de base/Impresora para que este módulo no dependa de aquel.
 */
export interface WaapiImpresionAccionProps {
  documento?: string | null
  titulo: string
  filename?: string
  destinatario?: {
    nombre?: string | null
    telefono?: string | null
    codigoPais?: string | null
    numero?: string | number | null
  }
  /** El documento habilita el envío por WhatsApp; si es false no se muestra el botón */
  whatsapp?: boolean
  obtenerUrlPublica: () => Promise<string | null>
  ocupado?: boolean
}

/**
 * Botón "Enviar por WhatsApp" para el diálogo de impresión. Solo se muestra si el documento lo
 * habilita (`imprimir({ whatsapp: true })`) y hay licencia `lw` vigente.
 * @example
 * <ImpresionDocumentoProvider accionesExtra={(ctx) => <WaapiImpresionAccion {...ctx} />}>
 */
const WaapiImpresionAccion: FunctionComponent<WaapiImpresionAccionProps> = ({
  documento,
  titulo,
  destinatario,
  whatsapp,
  obtenerUrlPublica,
  ocupado,
}) => {
  const { licenciaActiva } = useWaapi()
  const [abierto, setAbierto] = useState(false)
  if (!whatsapp || !licenciaActiva) return null

  const doc = waapiDocumento(documento)
  return (
    <>
      <Button
        fullWidth
        size="small"
        color="success"
        variant="outlined"
        startIcon={<WhatsApp />}
        disabled={ocupado}
        onClick={() => setAbierto(true)}
      >
        Enviar por WhatsApp
      </Button>
      {abierto && (
        <WaapiEnviarDialog
          open
          onClose={() => setAbierto(false)}
          titulo={`Enviar ${titulo} por WhatsApp`}
          obtenerUrl={obtenerUrlPublica}
          documento={doc}
          numero={destinatario?.numero}
          destinatario={destinatario}
          nombreArchivo={nombreArchivoWaapi({
            documento: doc,
            titulo,
            numero: destinatario?.numero,
            destinatario: destinatario?.nombre,
          })}
        />
      )}
    </>
  )
}

export default WaapiImpresionAccion
